<template>
    <div class="outer">

        <!-- 选择库存货物 -->
        <el-dialog width="60%" title="选择库存货物" destroy-on-close :close-on-click-modal="false"
            v-if="checkInventoryVisible" :visible="checkInventoryVisible" @close="checkInventoryVisible = false">
            <selectInventory :checkedList="claimForm.tbApplyGoodsListModelList" @addInventory="addInventory" :claimDialogType="claimDialogType">
            </selectInventory>
        </el-dialog>

        <!-- 选择货物弹窗 -->
        <el-dialog width="60%" title="选择货物" :close-on-click-modal="false" v-if="buyRequestGooodsVisable"
            :visible="buyRequestGooodsVisable" @close="closeRequestGooodsDialog">
            <addGoods :checkedList="claimForm.tbXzRequestGoodsListModelList" @checkGoods="checkGoods" :claimDialogType="claimDialogType"/>
        </el-dialog>

        <!-- 申领单弹窗 -->
        <el-dialog width="80%" destroy-on-close v-if="claimVisible" :title="claimDialogTitle"
            :close-on-click-modal="false" :visible="claimVisible" @close="closeClaimDialog">
            <div>
                <el-card style="margin-bottom: 30px">

                    <div class="flex-space-between listTop" slot="header">
                        <span>基本信息</span>
                        <!-- <div>
                            <el-button icon="el-icon-folder-checked" style="margin-right: 20px" 
                                v-if="claimDialogType === 'edit'" :disabled="saveDisabled"  @click="saveEdit" type="primary">保存基本信息修改</el-button>
                        </div> -->
                    </div>

                    <el-form ref="claimForm" :model="claimForm" :rules="claimRules" label-width="110px">
                        <el-row :gutter="100">
                            <el-col :span="12">
                                <el-form-item required label="申领用途类型" class="queryCol" prop="usageType">
                                    <el-select style="width: 100%" v-model="claimForm.usageType" @change="usageTypeChange"
                                        :disabled="claimDialogType !== 'add'">
                                        <el-option value="1" label="项目用" :disabled="!isXiaos"></el-option>
                                        <el-option value="2" label="申领人所属部门用"></el-option>
                                        <el-option value="4" label="办公(用品)用"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="项目名称" prop="chanceId" v-show="claimForm.usageType === '1' && isXiaos">
                                    <el-select style="width: 100%" filterable v-model="claimForm.chanceId"
                                        :disabled="claimForm.usageType !== '1' || claimDialogType !== 'add'"
                                        :placeholder="claimDialogType === 'add' ? '请选择': '无'">
                                        <el-option v-for="(item, i) in projectList" :key="i" :label="item.name"
                                            :value="item.code">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row :gutter="100">
                            <el-col :span="24">
                                <el-form-item label="申领理由" required prop="applyReason">
                                    <el-input v-model="claimForm.applyReason" :rows="4" type="textarea" placeholder="请输入"
                                        :disabled="claimDialogType !== 'add'">
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-card>

                <el-card style="margin-bottom: 30px"
                    v-if="!(claimDialogType === 'detail' && claimForm.tbApplyGoodsListModelList.length === 0)">
                    <div class="flex-space-between listTop" slot="header">
                        <span>申领货物列表</span>
                        <div>
                            <el-button icon="el-icon-s-home" v-if="claimDialogType === 'add' || claimDialogType === 'edit'" type="primary"
                            @click="checkInventoryVisible = true">库存寻货</el-button>
                        </div>
                    </div>

                    <el-table border style="width: 100%;" :row-style="{ height: '50px' }" :data="claimForm.tbApplyGoodsListModelList">
                        <el-table-column align="center" label="货物名称" prop="goodsName">
                        </el-table-column>
                        <el-table-column align="center" label="货物类别" prop="goodsClassName">
                        </el-table-column>
                        <el-table-column align="center" label="货物品牌" prop="goodsBrand">
                        </el-table-column>
                        <el-table-column align="center" label="货物型号" prop="goodsType">
                        </el-table-column>
                        <el-table-column align="center" label="货物配置" prop="goodsConfig">
                            <template slot-scope="scope"> 
                                <el-popover trigger="hover" placement="top" width="300">
                                    <p>{{ scope.row.goodsConfig }}</p>
                                    <div slot="reference">
                                        <p size="medium" style="white-space: nowrap;overflow: hidden;text-overflow:ellipsis;">{{ scope.row.goodsConfig}}</p>
                                    </div>
                                </el-popover>    
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="库存总数量" prop="storeGoodsNum">
                        </el-table-column>
                        <el-table-column
                            align="center"
                            label="平均价格(元)"
                            prop="price">
                        </el-table-column>
                        <el-table-column align="center" label="申领数量" width="180" prop="goodsNum">
                            <template slot-scope="scope">
                                <el-input style="width: 150px" type="number" v-if="claimDialogType === 'add'"
                                v-model="scope.row.goodsNum" :max="scope.row.storeGoodsNum" :min="1"
                                placeholder="请输入"></el-input>
                                <span v-else>{{ scope.row.goodsNum }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="货物单位" prop="goodsUnit">
                        </el-table-column>
                        <el-table-column align="center" label="操作" v-if="claimDialogType !== 'detail'" prop="operate">
                            <template slot-scope="scope">
                                <template v-if="claimDialogType === 'edit'">
                                    <el-button type="text" icon="el-icon-edit"
                                        @click="editRow(scope.row,'apply')">修改</el-button>
                                </template>

                                <el-button type="text" icon="el-icon-delete" style="color: #F56C6C"
                                    @click="deleteApplyGood(scope.row.id, scope.$index)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                    <div class="totalPrice">
                        <div class="price">合计:  {{ totalPrice }}元</div>
                    </div>
                </el-card>
            </div>
            
            <template v-if="$store.state.jxcSystemPermission.buyRequestCreate()">
                <el-card v-if="!(claimDialogType === 'detail' && claimForm.tbXzRequestGoodsListModelList.length === 0)" v-show="claimForm.usageType !== '4'">
                    <div class="flex-space-between listTop" slot="header">
                        <span>请购货物列表</span>
                        <div>
                            <el-button icon="el-icon-shopping-cart-full" type="primary" v-if="claimDialogType !== 'detail'"
                                @click="openRequestGooodsDialog">申购货物</el-button>
                        </div>
                    </div>
                    <el-table border :row-style="{ height: '50px' }" class="table" style="width: 100%" :data="claimForm.tbXzRequestGoodsListModelList">
                        <el-table-column align="center" label="货物名称" prop="goodsName">
                        </el-table-column>
                        <el-table-column align="center" label="货物类别" prop="goodsClassName">
                        </el-table-column>
                        <el-table-column align="center" label="货物品牌" prop="goodsBrand">
                        </el-table-column>
                        <el-table-column align="center" label="货物型号" prop="goodsType">
                        </el-table-column>
                        <el-table-column align="center" label="货物配置" prop="goodsConfig">
                            <template slot-scope="scope">
                                <el-popover trigger="hover" placement="top" width="300">
                                    <p>{{ scope.row.goodsConfig }}</p>
                                        <div slot="reference">
                                        <p size="medium" style="white-space: nowrap;overflow: hidden;text-overflow:ellipsis;">{{ scope.row.goodsConfig}}</p>
                                    </div>
                                </el-popover>        
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="货物品牌" prop="goodsBrand">
                        </el-table-column>
                        <el-table-column align="center" label="状态" prop="requestState" v-if="claimDialogType !== 'add'">
                            <template slot-scope="scope">
                                <el-tag :type="RstateTagType(scope.row.requestState)">{{ scope.row.requestStateName }}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="请购数量" :width="claimDialogType !== 'add' ? '' : '180'" prop="goodsNum">
                            <template slot-scope="scope">
                                <el-input style="width: 150px" type="number" v-if="claimDialogType === 'add'"
                                    v-model="scope.row.goodsNum" :min="1"
                                    placeholder="请输入"></el-input>
                                <span v-else>{{ scope.row.goodsNum }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="货物单位" prop="goodsUnit">
                        </el-table-column>

                        <template v-if="claimDialogType !== 'add'">
                            <el-table-column align="center" label="关联采购单号" prop="purchaseNo">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.purchaseNo">{{ scope.row.purchaseNo }}</span>
                                    <span v-else>--</span>
                                </template>
                            </el-table-column>
                            <!-- <el-table-column align="center" label="采购单状态" prop="purchaseState">
                                <template slot-scope="scope">
                                    <el-tag v-if="scope.row.purchaseState === '1'" type="info">{{scope.row.purchaseStateName}}</el-tag>
                                    <el-tag v-else-if="scope.row.purchaseState === '2'" type="primary">{{scope.row.purchaseStateName}}</el-tag>
                                    <el-tag v-else-if="scope.row.purchaseState === '3'" type="danger">{{scope.row.purchaseStateName}}</el-tag>
                                    <el-tag v-else-if="scope.row.purchaseState === '4'" type="success">{{scope.row.purchaseStateName}}</el-tag>
                                    <span v-else>--</span>
                                </template>
                            </el-table-column> -->
                        </template>
                        
                        <el-table-column align="center" label="操作" v-if="claimDialogType !== 'detail'" prop="operate">
                            <template slot-scope="scope" >
                                <div v-if="scope.row.requestState != 2 && scope.row.requestState != 4">
                                    <el-button type="text" icon="el-icon-edit" v-if="claimDialogType === 'edit'"
                                        @click="editRow(scope.row,'request')">修改</el-button>
                                    <el-button type="text" icon="el-icon-delete" style="color: #F56C6C"
                                        @click="deleteRequestGoods(scope.row.id, scope.$index)">删除</el-button>
                                </div>
                                <div v-else>
                                    --
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
            </template>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" :loading="btnLoading" v-if="claimDialogType === 'add'" @click="submitApplyOrder">确 定</el-button>
            </span>

        </el-dialog>

        <!-- 审批记录弹窗 -->
        <el-dialog width="50%" destroy-on-close title="审批记录" v-if="claimApprovalVisible" @close="closeClaimApprovalDialog" :close-on-click-modal="false" :visible="claimApprovalVisible">
        
            <div style="min-height: 200px;">
                <template v-if="stageList.length > 0">
                    <el-timeline style="margin-top: 30px">
                        <el-timeline-item
                            :timestamp="item.endTime"
                            v-for="(item, i) in stageList"
                            :type="item.approvalResult === '1' ? 'success' : item.approvalResult === '2' ? 'danger' : ''"
                            :key="i"
                        >
                            {{ i+1 }}.<template v-if="item.approvalResult">
                            【已审批-{{ item.approvalResultName }}】, 【操作人：{{
                                item.dealUserName
                            }}】, 【意见/建议：{{ item.opinion }}】
                            </template>
                            <template v-else>
                            【待审批】 【操作人：{{ item.dealUserName }}】
                            </template>
                        </el-timeline-item>
                    </el-timeline>

                    <div style="position: absolute;bottom: 20px;right: 20px;">
                        当前审批人: {{ currentApprovalUser }}
                    </div>
                </template>
                    
    
                <el-empty v-else description="无需审批"></el-empty>
            </div>
            
        </el-dialog>

        <!-- 顶部搜索框 -->
        <div class="topSearch">
            <el-form class="queryRow" inline :model="queryForm">
                <el-form-item label="项目名称" class="queryCol">
                    <el-select v-model="queryForm.chanceId" clearable filterable @change="onSearch" @clear="onSearch">
                        <el-option v-for="(item, i) in projectList" :key="i" :label="item.name"
                            :value="item.code"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="申领用途类型" class="queryCol">
                    <el-select v-model="queryForm.usageType" clearable @change="onSearch" @clear="onSearch">
                        <el-option :value="1" label="项目用"></el-option>
                        <el-option :value="2" label="申领人所属部门用"></el-option>
                        <el-option :value="4" label="办公(用品)用"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="申领单状态" class="queryCol">
                    <el-select v-model="queryForm.applyState" clearable @change="onSearch" @clear="onSearch">
                        <el-option :value="1" label="备货中"></el-option>
                        <el-option :value="2" label="审批中"></el-option>
                        <el-option :value="3" label="审批完成"></el-option>
                        <el-option :value="4" label="审批驳回"></el-option>
                        <el-option :value="5" label="已领用"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>

            <el-button type="primary" icon="el-icon-plus" @click="openClaimVisible('add')">
                新建申领单
            </el-button>
        </div>

        <el-table v-loading="loading" border class="el-table" :row-style="{ height: '50px' }"
            :cell-class-name="cellClassName" style="width: 100%; height: 70vh; overflow: auto;" :data="claimList">
            <template slot="empty">
                <el-empty :image-size="150"></el-empty>
            </template>
            <el-table-column type="expand" label=" " width="50">
                <template slot-scope="props">
                    <el-descriptions title="项目信息" class="demo-table-expand" :column="1">
                        <el-descriptions-item label="商机号">{{ props.row.chanceId }}</el-descriptions-item>
                        <el-descriptions-item label="商机名称">{{ props.row.chanceName }}</el-descriptions-item>
                    </el-descriptions>
                </template>
            </el-table-column>
            <el-table-column width="130" align="center" label="申领单编号" prop="applyNo">
            </el-table-column>
            <el-table-column align="center" label="申领用途类型" prop="usageTypeName">
            </el-table-column>
            <el-table-column align="center" label="申领理由" prop="applyReason">
            </el-table-column>
            <el-table-column align="center" label="申领单状态" prop="applyStateName">
                <template slot-scope="scope">
                    <el-tag :type="stateTagType(scope.row.applyState)" >{{ scope.row.applyStateName }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column align="center" label="申请时间" prop="createTime" min-width="130" :formatter="dateTimeTwoLine" class-name="cell-two-line">
            </el-table-column>
            <el-table-column align="center" label="操作" prop="operate">
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-document" class="Primary-text"
                        @click="openClaimVisible('detail', scope.row, scope.$index)">详情</el-button>
                    <el-button type="text" icon="el-icon-s-claim" @click="openApprovalVisible(scope.row.applyNo)">
                        审批记录
                    </el-button>
                    <el-button type="text" class="Primary-text" icon="el-icon-refresh-right" v-if="scope.row.applyState === '4'"
                        @click="openClaimVisible('add', scope.row, scope.$index)">重新申领</el-button>
                    <template v-if="scope.row.applyState !== '3' && scope.row.applyState !== '5'">
                        <el-button type="text" class="Danger-text" icon="el-icon-delete"
                            @click="deleteClaim(scope.row.id)">删除</el-button>
                    </template>
                </template>
            </el-table-column>
        </el-table>

        <div class="pageination">
            <el-pagination @size-change="onSizeChange" @current-change="onCurrentChange" :total="total"
                :page-size="queryForm.limit" :page-sizes="[10, 20, 30, 40, 50, 100]" :current-page="queryForm.page"
                background layout="sizes, prev, pager, next, jumper, ->, total">
            </el-pagination>
        </div>

    </div>
</template>
<script>
import { approvalStageList } from '@/api/goods/buyForm.js';
import {
    getApplyList,
    addApply,
    queryApplyUse,
    updateApplyUse,
    updateApplyGoods,
    updateXzRequestGoods,
    deleteApply,
    deleteApplyGoods,
    deleteRequestGoods,
    addApplyGoodsList,
    addXzRequestGoodsList,
    addOutStore,
} from '@/api/goods/applyForm.js';
import { getProjects, getAllProject } from '@/api/work/WorkOrderList.js';
import { isSales } from "@/views/goods/permission.js";
import selectInventory from './selectInventory.vue';
import addGoods from './addGoods.vue';
export default {
    data() {
        var checkGoodsNum = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('请输入货物数量'));
            }
            if (value && (value <= 0 || value.toString().includes('.'))) {
                callback(new Error('请输入正整数'));
            } else {
                callback();
            }
        }
        return {
            btnLoading: false, // 提交按钮是否禁用
            claimApprovalVisible: false, // 审批记录弹窗显隐
            stageList: [], // 审批记录列表
            activeTab: '1', // 当前tab
            outboundPerission: this.$store.state.jxcSystemPermission.AdminRole(), // 申领单审批权限 , uid === 202 卢雅静
            saveDisabled: true, // 保存基本信息按钮禁用状态
            userRoleId: sessionStorage.getItem('userRoleId'), // 用户角色ID
            activeName: '1', // 当前tab
            baseInfoIsEdit: false, // 基本信息是否编辑
            overTotalList: [], // 申领总数大于总数量列表
            requestGoodsTitle: '', // 请购单货物标题
            claimDialogTitle: '', // 申领单弹窗标题
            total: 0, // 表格总数
            loading: false, // 加载数据
            classOptions: [], // 货物分类列表
            isXiaos: isSales(), // 销售类角色（roleId 2、3）可选项目用/商机
            queryForm: {
                createUserId: '',
                chanceId: '',
                usageType: '',
                applyState: '',
                page: 1,
                limit: 10,
            },// 查询表单
            projectList: [], // 项目列表
            claimVisible: false, // 申领单弹窗显隐
            buyRequestGooodsVisable: false, // 请购单货物列表
            checkInventoryVisible: false, // 选中库存弹窗显隐
            buyRequestGooodsForm: {
                goodsName: '',
                goodsBrand: '',
                goodsType: '',
                goodsConfig: '',
                goodsNum: '',
                remarks: '',
            }, // 请购单货物表单
            buyRequestGooodsRules: {
                goodsName: [
                    { required: true, message: '请输入货物名称' },
                ],
                goodsBrand: [
                    { required: true, message: '请输入货物品牌' },
                ],
                goodsType: [
                    { required: true, message: '请输入货物型号' },
                ],
                goodsConfig: [
                    { required: true, message: '请输入货物配置' },
                ],
                goodsNum: [
                    { validator: checkGoodsNum, type: 'change' },
                ],
            }, // 请购单货物表单
            claimForm: {
                usageType: '',
                chanceId: '',
                applyReason: '',
                tbApplyGoodsListModelList: [],
                tbXzRequestGoodsListModelList: [],
            }, // 申领单填写表单
            claimRules: {
                usageType: [
                    { required: true, message: '请选择申领用途类型' },
                ],
                applyReason: [
                    { required: true, message: '请选择申领理由' },
                ]
            }, // 申领单表单验证
            claimList: [], // 申领单列表
            claimDialogType: '', // 申领单弹窗的类型 'add' 新增 'edit' 修改
        }
    },
    async created() {
        if (this.$route.params.applyNo) {
            this.activeName = '3';
        }
        await this.getApplyList();
        this.isXiaos ? this.getProjects() : this.getAllProject();
        
    },
    components: {
        selectInventory,
        addGoods,
    },
    computed: {
        totalPrice(){
            let total = 0;
            this.claimForm.tbApplyGoodsListModelList.forEach(item => {
                total += item.goodsNum * item.price;
            })
            return total;
        },
        currentApprovalUser(){
            return this.stageList.find(item => !item.approvalResult )?.dealUserName || '无';
        }
    },
    watch: {
        claimForm: {
            handler() {
                if (this.claimVisible) {
                    this.saveDisabled = false;
                }
            },
            deep: true,
        }
    },
    methods: {
        // 关闭审批记录弹窗
        closeClaimApprovalDialog(){
            this.stageList = [];
            this.claimApprovalVisible = false;
        },
        openApprovalVisible(applyNo){
            this.getApprovalStageList(applyNo);
            this.claimApprovalVisible = true;
        },
        RstateTagType(requestState){
            switch (requestState) {
                case '1':
                    return '';
                    break;
                case '2':
                    return 'primary';
                    break;
                case '3':
                    return 'danger';
                    break;
                case '4':
                    return 'success';
                    break;
            }

        },
        RstateTagName(requestState){
            switch (requestState) {
                case '1':
                    return '待审批';
                    break;
                case '2':
                    return '审批完成';
                    break;
                case '3':
                    return '审批驳回';
                    break;
                case '4':
                    return '已入库';
                    break;
            }

        },
        // 获取采购单审批记录
        getApprovalStageList(purchaseNo){
            approvalStageList({
                applyCode: purchaseNo,
            }).then(res => {
                if(res.code === 200){
                    this.stageList = res.data;
                }
            })
        },
        // 修改申领单或请购单的货物数量
        editRow(row, type){
            if(type === 'apply'){
                let text = '(库存总数量：' + row.storeGoodsNum + ')';
                this.$prompt('请输入申领数量' + text, '修改申领数量', {
                    inputValue: row.goodsNum,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputType: 'number',
                    inputValidator: (value) => {
                        if (!value) {
                            return '请输入申领数量';
                        }
                        if(value > row.storeGoodsNum){
                            return '申领数量大于库存总数量';
                        }
                    },
                }).then(({ value }) => {
                    updateApplyGoods({
                        id: row.id,   
                        goodsCode: row.goodsCode,
                        goodsNum: value
                    }).then(res => {
                        if(res.code === 200){
                            this.$message({
                                type: 'success',
                                message: '修改申领数量成功',
                            });

                            this.queryApplyUse(this.claimForm); 
                        }
                    })
                })
            }else if (type === 'request'){
                this.$prompt('请输入请购数量', '修改请购数量', {
                    inputValue: row.goodsNum,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputType: 'number',
                    inputValidator: (value) => {
                        if (!value) {
                            return '请输入请购数量';
                        }
                    },
                }).then(({ value }) => {
                    updateXzRequestGoods({
                        ...row,
                        goodsNum: value
                    }).then(res => {
                        if(res.code === 200){
                            this.$message({
                                type: 'success',
                                message: '修改请购数量成功',
                            });
                            this.queryApplyUse(this.claimForm); 
                        }
                    })
                })
            }
        },
        // 请购单选择货物回调
        checkGoods(selectionList){
            if(this.claimDialogType === 'add'){
                this.claimForm.tbXzRequestGoodsListModelList = this.claimForm.tbXzRequestGoodsListModelList.concat(selectionList);
                this.buyRequestGooodsVisable = false;
            }else if(this.claimDialogType === 'edit'){
                let addGoodsObj = selectionList[0]
                addXzRequestGoodsList({
                    applyNo: this.claimForm.applyNo,
                    goodsCode: addGoodsObj.goodsCode,
                    goodsNum: addGoodsObj.goodsNum,
                }).then(res => {
                    if(res.code === 200){
                        this.$message({
                            type: 'success',
                            message: '添加请购货物成功',
                        });
                        this.queryApplyUse(this.claimForm); 
                        this.buyRequestGooodsVisable = false;
                    }
                })
            } 
        },
        // 表格单元格样式
        cellClassName({ row, column }) {
            if (column.type === 'expand' && row.usageType !== '1') {
                return 'hidden-row'
            }
            return ''
        },
        // 申领数量输入框只能输入正整数
        onInput(row) {
            row.goodsNum = row.goodsNum.replace(/^[0-9]*[1-9][0-9]*$/g, '');
        },
        // 申领单状态标签颜色
        stateTagType(state) {
            switch (state) {
                case '1':
                    return 'warning';
                    break;
                case '2':
                    return 'info';
                    break;
                case '3':
                    return '';
                    break;
                case '4':
                    return 'danger';
                    break;
                case '5':
                    return 'success';
                    break;
            }
        },
        // 打开选择货物弹窗
        openRequestGooodsDialog() {
            this.buyRequestGooodsVisable = true;
        },
        // 关闭请购单货物列表
        closeRequestGooodsDialog() {
            this.buyRequestGooodsVisable = false;
        },
        // 删除请购的货物
        deleteRequestGoods(id, index) {
            this.$confirm('确定删除这条请购记录吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                if (this.claimDialogType === 'add') {
                    this.claimForm.tbXzRequestGoodsListModelList.splice(index, 1);
                } else if (this.claimDialogType === 'edit') {
                    deleteRequestGoods({
                        id
                    }).then(res => {
                        if (res.code === 200) {
                            this.$message({
                                type: 'success',
                                message: '删除请领货物成功',
                            })
                            this.queryApplyUse(this.claimForm);
                        }
                    })
                }
            })
        },
        // 删除申领的货物
        deleteApplyGood(id, index) {
            this.$confirm('确定删除这个申领的货物吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                
                if (this.claimDialogType === 'add') {
                    this.claimForm.tbApplyGoodsListModelList.splice(index, 1);
                    this.$message({
                        type: 'success',
                        message: '删除申领货物成功',
                    })
                } else if (this.claimDialogType === 'edit') {
                    deleteApplyGoods({
                        id
                    }).then(res => {
                        if (res.code === 200) {
                            this.$message({
                                type: 'success',
                                message: '删除申领货物成功',
                            })
                            this.queryApplyUse(this.claimForm);
                        }
                    })
                }
            })
        },
        // 删除申领单
        deleteClaim(id) {
            this.$confirm('确定删除这个申领单吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteApply({ id }).then(res => {
                    if (res.code === 200) {
                        this.$message({
                            type: 'success',
                            message: '删除申领单成功',
                        })
                        this.getApplyList()
                    }
                })
            })
        },
        // 申领单基本信息保存
        saveEdit() {
            this.$refs.claimForm.validate((valid) => {
                if (valid) {
                    if(this.claimForm.usageType === '1' && !this.claimForm.chanceId) {
                        this.$message({
                            type: 'error',
                            message: '请选择项目名称',
                        });
                        return;
                    }
                    
                     let sendObj = {
                        "applyNo": this.claimForm.applyNo,
                        "usageType": this.claimForm.usageType,
                        "applyReason": this.claimForm.applyReason
                    }

                    if (this.claimForm.usageType === '1') sendObj.chanceId = this.claimForm.chanceId
                    updateApplyUse(sendObj).then(res => {
                        if (res.code === 200) {
                            this.$message({
                                type: 'success',
                                message: '保存修改成功',
                            })
                            this.saveDisabled = true;
                        }
                    })
                }
            })  
        },
        // 关闭申领单弹窗
        closeClaimDialog() {
            this.claimForm = {
                usageType: '',
                chanceId: '',
                applyReason: '',
                tbApplyGoodsListModelList: [],
                tbXzRequestGoodsListModelList: [],
            };
            this.$refs.claimForm.resetFields();
            this.saveDisabled = true;
            this.claimVisible = false;
        },
        // 查询申领单货物明细
        async queryApplyUse(row) {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            await queryApplyUse({ applyNo: row.applyNo }).then(res => {
                if (res.code === 200) {
                    this.claimForm = res.result;
                    loading.close();
                }
            })
        },
        // 打开申领单
        async openClaimVisible(type, row) {
            this.claimDialogType = type;
            if (type === 'add') {
                this.claimDialogTitle = '新增申领单';
                if(row) await this.queryApplyUse(row);
            } else if (type === 'edit') {
                this.claimDialogTitle = '修改申领单';
                await this.queryApplyUse(row);
            } else {
                this.claimDialogTitle = '申领单详情';
                await this.queryApplyUse(row);
                // 获取采购单审批记录
                // this.getApprovalStageList(row.applyNo);
            }
            this.claimVisible = true;
        },
        // 提交申领单
        submitApplyOrder() {
            if (this.claimDialogType === 'add') {
                this.$refs.claimForm.validate((valid) => {
                    if (valid) {

                        if(this.claimForm.usageType === '1' && !this.claimForm.chanceId) {
                            this.$message({
                                type: 'error',
                                message: '请选择项目名称',
                            });
                            return;
                        }
                        
                        if (this.claimForm.tbApplyGoodsListModelList.length === 0 && this.claimForm.tbXzRequestGoodsListModelList.length === 0) {
                            this.$message({
                                type: 'error',
                                message: '申领货物和请购货物为空',
                            });
                            return;
                        }

                        this.overTotalList = [];
                        this.claimForm.tbApplyGoodsListModelList.forEach(item => {
                            if (item.goodsNum > item.storeGoodsNum) {
                                this.overTotalList.push(item);
                                item.overTotaltip = true;
                            }
                        })

                        if (this.overTotalList.length > 0) {
                            this.$message({
                                type: 'error',
                                message: `${this.overTotalList.map(item => item.goodsName).join(',')}申领数量不能大于库存总数量`,
                            })
                            return;
                        }

                        this.claimForm.tbApplyGoodsListModelList = this.claimForm.tbApplyGoodsListModelList.map((item, i) => {
                            item.xh = i + 1;
                            return item;
                        })

                        // 加载中提示
                        const loading = this.$loading({
                            lock: true,
                            text: 'Loading',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.7)'
                        });
                        this.btnLoading = true;
                        addApply(this.claimForm).then(res => {
                            this.btnLoading = false;
                            if (res.code === 200) {
                                this.$message({
                                    type: 'success',
                                    message: '新增成功',
                                });
                                this.claimVisible = false;
                                this.closeClaimDialog();
                                // this.closeClaimVisible(); 
                                this.getApplyList();
                                loading.close();
                            }else{
                                loading.close();
                            }
                        }).catch(() => {
                            loading.close();
                        });
                    }
                })
            }
        },
        // 添加仓库内的货物
        addInventory(selectList) {
            if(this.claimDialogType === 'add'){
                let concatList = selectList.map(item => {
                    return { ...item };
                })
                
                this.claimForm.tbApplyGoodsListModelList = this.claimForm.tbApplyGoodsListModelList.concat(concatList);
                this.checkInventoryVisible = false;
            }else if(this.claimDialogType === 'edit'){
                let addGoodsObj = selectList[0];
                console.log(addGoodsObj);
                addApplyGoodsList({
                    applyNo: this.claimForm.applyNo,
                    goodsCode: addGoodsObj.goodsCode,
                    goodsNum: addGoodsObj.goodsNum,
                    xh: this.claimForm.tbApplyGoodsListModelList[this.claimForm.tbApplyGoodsListModelList.length - 1].xh + 1
                }).then(res => {
                    if(res.code === 200){
                        this.$message({
                            type: 'success',
                            message: '添加成功',
                        });
                        this.checkInventoryVisible = false;
                        this.queryApplyUse(this.claimForm); 
                    }
                })
            }
            
        },
        // 申领用途类型改变
        usageTypeChange(e) {
            this.claimForm.chanceId = '';
            if(e == 4){
                this.claimForm.tbXzRequestGoodsListModelList = [];
            }
            
        },
        // 当每页条数变化
        onSizeChange(e) {
            this.queryForm.page = 1;
            this.queryForm.limit = e;
            this.getApplyList();
        },
        // 当页码发生变化时
        onCurrentChange(e) {
            this.queryForm.page = e;
            this.getApplyList();
        },
        onSearch() {
            this.queryForm.page = 1;
            this.getApplyList();
        },
        // 获取申领单列表
        getApplyList() {
            this.loading = true;
            getApplyList(this.queryForm).then(res => {
                if (res.code === 200) {
                    this.total = res.count;
                    this.claimList = res.data;
                    this.loading = false;
                }
            })
        },
        getProjects() {
            getProjects().then(res => {
                if (res.code === 200) {
                    this.projectList = res.data
                }
            })
        },
        getAllProject() {
            getAllProject().then(res => {
                if (res.code === 200) {
                    this.projectList = res.result
                }
            })
        }
    },
}
</script>
<style lang="scss" scoped>
.outer {
    .tipBorder{
        border-color: rgb(245, 108, 108) !important;
    }

    .listTop {
        margin-bottom: 15px;
        font-size: 15px;
        font-weight: 450;
    }

    .demo-table-expand {
        font-size: 0;
        margin-left: 65px;

        ::v-deep .el-form-item__label {
            width: 90px;
            color: #99a9bf;
        }

        .el-form-item {
            margin-right: 0;
            margin-bottom: 0;
            width: 50%;
        }
    }

    .totalPrice {
        display: flex;
        justify-content: flex-end;
        margin-top: 15px;
        font-size: 16px;

        .price {
            margin-right: 20px
        }
    }

    .clearfix {
        display: flex;
        justify-content: flex-end;
    }

    .el-form-item {
        margin-right: 20px;
    }

    .pageination {
        display: flex;
        justify-content: flex-end;
        margin-top: 5px;
    }

    .topSearch {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
    }

    .queryRow {
        overflow: hidden;
        display: flex;

        .queryName {
            width: 300px;
            margin-right: 10px;
        }

        .dataPicker {
            margin-right: 10px;
        }
    }

    .detailTable {
        ::v-deep .el-checkbox__input {
            &.is-checked {
                .el-checkbox__inner {
                    background-color: #409EFF;
                    border-color: #409EFF;
                }
            }
        }
    }

    .el-table {

        ::v-deep .hidden-row .cell {
            visibility: hidden;
        }

        ::v-deep .el-tooltip__popper {
            font-size: 14px;
            max-width: 40%
        }

        // ::v-deep .el-table__cell{
        //     >:empty::before{
        //         content: '--';
        //         color: gray;
        //     }
        // }
        
    }
}
</style>
